export const environment = {
  production: true,
  firebase: {
    apiKey: "AIzaSyDG-CKpyJxhOkM5dNdKalTT6H16_nPSvjs",
    authDomain: "bd-edu-plat.firebaseapp.com",
    databaseURL: "https://bd-edu-plat.firebaseio.com",
    projectId: "bd-edu-plat",
    storageBucket: "bd-edu-plat.appspot.com",
    messagingSenderId: "430001958500",
    appId: "1:430001958500:web:2a85a405933f81adea7971",
    measurementId: "G-HYZZR8YY1V"
  }
};


